import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { RULES_TYPE } from '../../../common/constant'
import { getProfileDetail } from '../../store/thunk'
import { CREATE_PROFILE_TYPE } from '../constant'
import { getIdsTableSetting } from '../helper'
import { getPortfolios, getProfileDefault } from './thunk'

const initialState = {
  createProfileType: CREATE_PROFILE_TYPE.NEW,

  errors: {
    profileAlertsName: null,
  },

  portfolios: [],
  portfolioIds: [],
  portfolioById: {},
  paramsRaw: {},

  idTable: {
    [RULES_TYPE.EVENT_RULES]: [],
    [RULES_TYPE.SCORE_RULES]: [],
    [RULES_TYPE.FINANCIAL_RULES]: [],
  },
  otherSetting: {
    portfolios: [],
  },
  dataTable: {},
  loading: {
    portfolios: true,
    profileDetail: false,
    getProfileDetail: false,
  },
}

export const slice = createSlice({
  name: 'alerts/settings/createEditProfile',
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeSettings: (state, action) => {
      const { keepProfileName, ...others } = action.payload
      const name = state.settings.profileAlertsName
      state.settings = { ...state.settings, ...others }
      if (keepProfileName) state.settings.profileAlertsName = name
    },
    changeCreateProfileType: (state, action) => {
      state.createProfileType = action.payload
    },
    changeErrors: (state, action) => {
      state.errors = { ...state.errors, ...action.payload }
    },
    changeSettingTable: (state, action) => {
      const { id, value } = action.payload
      state.dataTable[id] = value
    },
    changeSettingOther: (state, action) => {
      state.otherSetting = { ...state.otherSetting, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    // getPortfolios
    builder.addCase(getPortfolios.pending, (state) => {
      state.loading.portfolios = true
    })
    builder.addCase(getPortfolios.fulfilled, (state, action) => {
      state.portfolios = action.payload
      state.portfolioIds = action.payload.map((item) => item.portfolioId)
      state.portfolioById = keyBy(action.payload, 'portfolioId')
      state.loading.portfolios = false
    })
    builder.addCase(getPortfolios.rejected, (state, action) => {
      state.loading.portfolios = action.payload.loading
    })
    //getProfileDefault
    builder.addCase(getProfileDefault.pending, (state) => {
      state.loading.getProfileDefault = true
    })
    builder.addCase(getProfileDefault.fulfilled, (state, { payload }) => {
      const { profileSettings, ...otherSetting } = payload
      state.otherSetting = { ...otherSetting }
      state.idTable = getIdsTableSetting(profileSettings)
      state.dataTable = keyBy(profileSettings, 'alertCriteriaId')
      state.loading.getProfileDefault = false
    })
    builder.addCase(getProfileDefault.rejected, (state, action) => {
      state.loading.getProfileDefault = action.payload.loading
    })
    //getDetailProfile
    builder.addCase(getProfileDetail.pending, (state) => {
      state.loading.getProfileDetail = true
    })
    builder.addCase(getProfileDetail.fulfilled, (state, { payload }) => {
      const { profileSettings, ...otherSetting } = payload

      state.otherSetting = { ...otherSetting }
      state.idTable = getIdsTableSetting(profileSettings)
      state.dataTable = keyBy(profileSettings, 'alertCriteriaId')
      const paramsRaw = {
        ...payload,
        portfolioIds: otherSetting.portfolios.map((item) => item.portfolioId),
      }
      delete paramsRaw.portfolios
      state.paramsRaw = paramsRaw
      state.loading.getProfileDetail = false
    })
    builder.addCase(getProfileDetail.rejected, (state, action) => {
      state.loading.getProfileDetail = action.payload.loading
    })
  },
})

export const selectCreateProfileType = (state) =>
  state[slice.name].createProfileType

export const selectErrors = (key, callback) => (state) => {
  const errors = state[slice.name].errors
  const data = key ? errors[key] : errors
  return callback ? callback(data) : data
}

export const selectPortfolios = (state) => state[slice.name].portfolios
export const selectPortfolioIds = (state) => state[slice.name].portfolioIds
export const selectPortfolioById = (id, attr) => (state) => {
  const data = state[slice.name].portfolioById
  if (!id) return data
  if (!attr) return data[id]
  return data[id]?.[attr]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return state[slice.name].loading[type]
}

export const selectIdsTable = (type) => (state) =>
  type ? state[slice.name].idTable[type] : state[slice.name].idTable

export const selectDataTable = (id) => (state) =>
  id ? state[slice.name].dataTable[id] : state[slice.name].dataTable

export const selectOtherSetting = (type) => (state) =>
  type ? state[slice.name].otherSetting[type] : state[slice.name].otherSetting

export const selectParamsRaw = (state) => state[slice.name].paramsRaw

export const selectSettingParams = (state) => {
  const params = {
    ...state[slice.name].otherSetting,
    portfolioIds: state[slice.name].otherSetting.portfolios.map(
      (item) => item.portfolioId,
    ),
    profileSettings: Object.values(state[slice.name].dataTable),
  }
  delete params.portfolios
  return params
}

export const {
  resetStore,
  changeCreateProfileType,
  changeErrors,
  changeSettingTable,
  changeSettingOther,
} = slice.actions

register(slice.name, slice.reducer)
